import Reveal from "@/components/Reveal";
import Cta from "@/components/Cta";
import { Icon } from "@/components/Icon";
import { SERVICES } from "@/lib/content";

const ServicesGrid = () => {
  return (
    <section className="bg-[#F5F6FB]" data-testid="services-grid">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-24 lg:py-28">
        <Reveal className="max-w-2xl">
          <p className="text-[13px] font-semibold uppercase tracking-[0.18em] text-[#4B5CAB]">
            What we do
          </p>
          <h2 className="mt-4 font-heading text-3xl sm:text-4xl font-bold tracking-[-0.02em] text-[#2A2E7A] leading-[1.15]">
            Services designed to keep your business running smoothly
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {SERVICES.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.1}>
              <div
                data-testid={`service-card-${s.title.toLowerCase()}`}
                className="group h-full bg-white p-8 lg:p-9 rounded-lg border border-[#2A2E7A]/8 shadow-[0_1px_2px_rgba(36,59,99,0.04)] flex flex-col items-start gap-6 transition-[box-shadow,transform,border-color] duration-300 ease-out hover:-translate-y-1 hover:shadow-[0_24px_48px_-24px_rgba(36,59,99,0.28)] hover:border-[#4B5CAB]/25"
              >
                <span className="flex h-12 w-12 items-center justify-center rounded-[8px] bg-[#2A2E7A] transition-colors duration-300 group-hover:bg-[#34418C]">
                  <Icon name={s.icon} className="h-6 w-6 text-white" strokeWidth={1.6} />
                </span>
                <div>
                  <h3 className="font-heading text-xl font-semibold text-[#2A2E7A] tracking-[-0.01em]">
                    {s.title}
                  </h3>
                  <p className="mt-3 text-[15px] text-[#51607A] leading-[1.75]">{s.summary}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2} className="mt-12">
          <Cta to="/services" variant="primary" withArrow testId="services-grid-view-all">
            View All Services
          </Cta>
        </Reveal>
      </div>
    </section>
  );
};

export default ServicesGrid;
